import React, { useState, useEffect } from "react";
import { Button, Layout, Menu, Typography, Drawer, Image, Dropdown, Avatar } from "antd";
import { MenuOutlined } from "@ant-design/icons"; // Hamburger Icon
import {
  AiOutlineDashboard,
  AiOutlineUser,
  AiOutlineTeam,
  AiOutlineHome,
  AiOutlineFlag,
  AiOutlineIdcard,
  AiOutlineMessage,
  AiOutlineFormatPainter,
  AiTwotoneFileImage,
  AiOutlineFieldTime,
  AiTwotoneFile,
  AiOutlineForm,
  AiOutlineOrderedList,
  AiOutlineAccountBook,
  AiTwotoneEdit,
  AiOutlineUpload,
  AiOutlineCar,
  AiOutlineLaptop,
} from "react-icons/ai";
import { FaUsers } from "react-icons/fa";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";

import colors from "../assets/styles/colour"; // Assuming you have a colors file for consistent styling
import Logo from "../assets/images/bjp final.png";
import { APP_VERSION } from "../appVersion";
import "./Layout.css";
import { DownOutlined } from "@ant-design/icons";
import MenuDivider from "antd/es/menu/MenuDivider";
const { Header, Sider, Content } = Layout;


const SimpleLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const role = localStorage.getItem("UserRole");
  const navigate = useNavigate();
  const location = useLocation();
  const Name = localStorage.getItem("username");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const selectedKey = location.pathname.split("/").pop();
 
  // Handle screen resize for responsiveness
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCollapsed(true);
        setIsMobile(true);
      } else {
        setCollapsed(false);
        setIsMobile(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Define role-based menu items
  
  const items =
    role === "SUPERADMIN"
    ?[
      {
          key: "dashboard",
          icon: <AiOutlineDashboard />,
          label: "Dashboard",
        },
         { key: "send-message", icon: <AiOutlineMessage />, label: "Message", disabled: true },
          {
            key: "grievance",
            icon: <AiOutlineForm />,
            label: "Grievance",
            children: [
              {
                key: "grievance",
                icon: <AiOutlineForm />,
                label: "Create Grievances",
              },
              
              {
                key: "all-grievance",
                icon: <AiOutlineOrderedList />,
                label: "Grievance List",
              },
            ],
          },
          {
            key: "event-planner",
            icon: <AiTwotoneEdit />,
            label: "Event Planner",
            disabled: true,
          },

         {
            key: "admin-appointment",
            icon: <AiOutlineFieldTime />,
            label: "Appointment",
            disabled: true,
          },
          { key: "manage-user", icon: <AiOutlineUser />, label: "Manage User" },
          {
            key: "asset-management",
            icon: <AiOutlineLaptop />,
            label: "Asset Management",
          },
          {
            key: "employee-management",
            icon: <FaUsers />,
            label: "Employee Management",
          },
          {
            key: "transport",
            icon: <AiOutlineCar />,
            label: "Transport",
            children: [
              {
                key: "driver-management",
                icon: <AiOutlineCar />,
                label: "Drivers",
                // children: [
                //   {
                //     key: "DriverRegistration",
                //     icon: <AiOutlineCar />,
                //     label: "Add Driver",
                //   },
                //   {
                //     key: "driver-management",
                //     icon: <AiOutlineCar />,
                //     label: "Manage Driver",
                //   },
                // ],
              },
              {
                key: "trip-management",
                icon: <AiOutlineCar />,
                label: "Trips",
                // children: [
                //   {
                //     key: "add-trip",
                //     icon: <AiOutlineCar />,
                //     label: "Add Trip",
                //   },
                //   {
                //     key: "trip-management",
                //     icon: <AiOutlineCar />,
                //     label: "Manage Trip",
                //   },
                // ],
              },
              {
                key: "vehicle-management",
                icon: <AiOutlineCar />,
                label: "Vehicles",
                // children: [
                //   {
                //     key: "TransportDetails",
                //     icon: <AiOutlineCar />,
                //     label: "Add Vehicle",
                //   },
                //   {
                //     key: "vehicle-management",
                //     icon: <AiOutlineCar />,
                //     label: "Manage Vehicle",
                //   },
                // ],
              },
            ],
          },
             {
            key: "feedback",
            icon: <FaUsers />,
            label: "Feedback Management",
          },
    ]

   : role === "ADMIN"
      ? [
        {
          key: "dashboard",
          icon: <AiOutlineDashboard />,
          label: "Dashboard",
        },
          // {
          //   key: "upload",
          //   icon: <AiOutlineUpload />,
          //   label: "Upload",
          //   children: [
          //     {
          //       key: "constituency",
          //       icon: <AiOutlineFlag />,
          //       label: "Parliament",
          //     },
          //     { key: "assembly", icon: <AiOutlineTeam />, label: "Assembly" },
          //     { key: "panchayat", icon: <AiOutlineHome />, label: "Panchayat" },
          //     { key: "booth", icon: <AiOutlineFlag />, label: "Booth" },
          //   ],
          // },
          // {
          //   key: "constituency",
          //   icon: <AiOutlineFlag />,
          //   label: "Parliament",
          // },
          // { key: "assembly", icon: <AiOutlineTeam />, label: "Assembly" },
          // { key: "panchayat", icon: <AiOutlineHome />, label: "Panchayat" },
          // { key: "booth", icon: <AiOutlineFlag />, label: "Booth" },
          // { key: "voters", icon: <AiOutlineIdcard />, label: "Voters" },
          // { key: "add-voters", icon: <AiOutlineIdcard />, label: "Add Voters" },
          { key: "send-message", icon: <AiOutlineMessage />, label: "Message", disabled: true },

          // {
          //   key: "past-analysis",
          //   icon: <AiOutlineOrderedList />,
          //   label: "Past Elections",
          // },

          // {
          //   key: "form",
          //   icon: <AiOutlineFlag />,
          //   label: "Surveys",
          //   children: [
          //     {
          //       key: "create-survey",
          //       icon: <AiOutlineFlag />,
          //       label: "Create Survey",
          //     },
          //     {
          //       key: "survey-lists",
          //       icon: <AiOutlineIdcard />,
          //       label: "Survey Lists",
          //     },
          //   ],
          // },
          {
            key: "grievance",
            icon: <AiOutlineForm />,
            label: "Grievance",
            children: [
              {
                key: "grievance",
                icon: <AiOutlineForm />,
                label: "Create Grievances",
              },
             
              {
                key: "all-grievance",
                icon: <AiOutlineOrderedList />,
                label: "Grievance List",
              },
            ],
          },

          // {
          //   key: "election",
          //   icon: <AiOutlineFlag />,
          //   label: "Election",
          //   children: [
          //     {
          //       key: "election-details",
          //       icon: <AiOutlineAccountBook />,
          //       label: "Details Upload",
          //     },
          //     {
          //       key: "admin-election-details",
          //       icon: <AiOutlineIdcard />,
          //       label: "Election Details",
          //     },
          //   ],
          // },
          {
            key: "event-planner",
            icon: <AiTwotoneEdit />,
            label: "Event Planner",
            disabled: true,
          },
          // {
          //   key: "About",
          //   icon: <AiOutlineUpload />,
          //   label: "About",
          //   children: [
          //     {
          //       key: "about-constituency",
          //       icon: <AiOutlineFlag />,
          //       label: "About Parliament ",
          //     },
          //     {
          //       key: "about-assembly",
          //       icon: <AiOutlineTeam />,
          //       label: "About Assembly",
          //     },
          //   ],
          // },
          {
            key: "admin-appointment",
            icon: <AiOutlineFieldTime />,
            label: "Appointment",
            disabled: true,
          },
          // { key: "manage-user", icon: <AiOutlineUser />, label: "Manage User" },
          {
            key: "asset-management",
            icon: <AiOutlineLaptop />,
            label: "Asset Management",
          },
          {
            key: "employee-management",
            icon: <FaUsers />,
            label: "Employee Management",
          },
          {
            key: "transport",
            icon: <AiOutlineCar />,
            label: "Transport",
            children: [
              {
                key: "driver-management",
                icon: <AiOutlineCar />,
                label: "Drivers",
                // children: [
                //   {
                //     key: "DriverRegistration",
                //     icon: <AiOutlineCar />,
                //     label: "Add Driver",
                //   },
                //   {
                //     key: "driver-management",
                //     icon: <AiOutlineCar />,
                //     label: "Manage Driver",
                //   },
                // ],
              },
              {
                key: "trip-management",
                icon: <AiOutlineCar />,
                label: "Trips",
                // children: [
                //   {
                //     key: "add-trip",
                //     icon: <AiOutlineCar />,
                //     label: "Add Trip",
                //   },
                //   {
                //     key: "trip-management",
                //     icon: <AiOutlineCar />,
                //     label: "Manage Trip",
                //   },
                // ],
              },
              {
                key: "vehicle-management",
                icon: <AiOutlineCar />,
                label: "Vehicles",
                // children: [
                //   {
                //     key: "TransportDetails",
                //     icon: <AiOutlineCar />,
                //     label: "Add Vehicle",
                //   },
                //   {
                //     key: "vehicle-management",
                //     icon: <AiOutlineCar />,
                //     label: "Manage Vehicle",
                //   },
                // ],
              },
            
            ],
            
          },
          
           {
            key: "feedback",
            icon: <FaUsers />,
            label: "Feedback Management",
          },
         
        ]
      : role === "PANCHAYAT"
      ? [
          // {
          //   key: "dashboard",
          //   icon: <AiOutlineDashboard />,
          //   label: "Dashboard",
          // },
          // {
          //   key: "panchayat-details",
          //   icon: <AiOutlineUser />,
          //   label: "Panchayat Details",
          // },
          {
            key: "grievance",
            icon: <AiOutlineForm />,
            label: "Grievance Form",
          },
          {
            key: "grievance-list",
            icon: <AiOutlineOrderedList />,
            label: "Grievance List",
          },
          {
            key: "panchayat-grievance",
            icon: <AiOutlineOrderedList />,
            label: "Assigned Grievance",
          },
          // {
          //   key: "panchayat-gallery",
          //   icon: <AiTwotoneFile />,
          //   label: "Gallery",
          // },
          {
            key: "admin-appointment",
            icon: <AiOutlineFieldTime />,
            label: "Appointment",
          },
           {
            key: "feedback",
            icon: <FaUsers />,
            label: "Feedback Management",
          },
        ]
      : role === "BOOTH"
      ? [
          // {
          //   key: "dashboard",
          //   icon: <AiOutlineDashboard />,
          //   label: "Dashboard",
          // },
          // {
          //   key: "booth-details",
          //   icon: <AiOutlineUser />,
          //   label: "Booth Details",
          // },
          {
            key: "grievance",
            icon: <AiOutlineForm />,
            label: "Grievance Form",
          },
          {
            key: "grievance-list",
            icon: <AiOutlineOrderedList />,
            label: "Grievance List",
          },
          {
            key: "booth-grievance",
            icon: <AiOutlineOrderedList />,
            label: "Assigned Grievance",
          },
          // {
          //   key: "booth-gallery",
          //   icon: <AiTwotoneFile />,
          //   label: "Gallery",
          // },
          {
            key: "admin-appointment",
            icon: <AiOutlineFieldTime />,
            label: "Appointment",
          },
        ]
      : role === "ASSEMBLY"
      ? [
          {
            key: "dashboard",
            icon: <AiOutlineDashboard />,
            label: "Dashboard",
          },
          // {
          //   key: "assembly-details",
          //   icon: <AiOutlineUser />,
          //   label: "About Assembly",
          // },
          // {
          //   key: "assembly-election-details",
          //   icon: <AiOutlineUser />,
          //   label: "Past Election",
          // },
          // { key: "voters", icon: <AiOutlineIdcard />, label: "Voters" },
          {
            key: "grievance",
            icon: <AiOutlineForm />,
            label: "Grievance",
            children: [
              {
                key: "grievance",
                icon: <AiOutlineForm />,
                label: "Grievance Form",
              },
              {
                key: "all-grievance",
                icon: <AiOutlineOrderedList />,
                label: "Grievance List",
              },
              {
                key: "constituency-grievance",
                icon: <AiOutlineOrderedList />,
                label: "Assigned Grievance",
              },
            ],
          },
          {
            key: "event-planner",
            icon: <AiTwotoneEdit />,
            label: "Event Planner",
          },
          {
            key: "form",
            icon: <AiOutlineFlag />,
            label: "Surveys",
            children: [
              {
                key: "create-survey",
                icon: <AiOutlineFlag />,
                label: "Create Survey",
              },
              {
                key: "survey-lists",
                icon: <AiOutlineIdcard />,
                label: "Survey Lists",
              },
            ],
          },
          // {
          //   key: "assembly-gallery",
          //   icon: <AiTwotoneFile />,
          //   label: "Gallery",
          // },
          {
            key: "admin-appointment",
            icon: <AiOutlineFieldTime />,
            label: "Appointment",
          },
           {
            key: "feedback",
            icon: <FaUsers />,
            label: "Feedback Management",
          },
        ]
      : role === "CONSTITUENCY"
      ? [
          {
            key: "dashboard",
            icon: <AiOutlineDashboard />,
            label: "Dashboard",
          },
          // {
          //   key: "constituency-details",
          //   icon: <AiOutlineUser />,
          //   label: "About Parliament",
          // },
          // {
          //   key: "parliament-election-details",
          //   icon: <AiOutlineUser />,
          //   label: "Past Election",
          // },
          // { key: "voters", icon: <AiOutlineIdcard />, label: "Voters" },
          {
            key: "grievance",
            icon: <AiOutlineForm />,
            label: "Grievance",
            children: [
              {
                key: "grievance",
                icon: <AiOutlineForm />,
                label: "Grievance Form",
              },
              {
                key: "all-grievance",
                icon: <AiOutlineOrderedList />,
                label: "Grievance List",
              },
              {
                key: "constituency-grievance",
                icon: <AiOutlineOrderedList />,
                label: "Assigned Grievance",
              },
            ],
          },
          {
            key: "event-planner",
            icon: <AiTwotoneEdit />,
            label: "Event Planner",
          },
          {
            key: "form",
            icon: <AiOutlineFlag />,
            label: "Surveys",
            children: [
              {
                key: "create-survey",
                icon: <AiOutlineFlag />,
                label: "Create Survey",
              },
              {
                key: "survey-lists",
                icon: <AiOutlineIdcard />,
                label: "Survey Lists",
              },
            ],
          },
          // {
          //   key: "constituency-gallery",
          //   icon: <AiTwotoneFile />,
          //   label: "Gallery",
          // },
          {
            key: "admin-appointment",
            icon: <AiOutlineFieldTime />,
            label: "Appointment",
          },
           {
            key: "feedback",
            icon: <FaUsers />,
            label: "Feedback Management",
          },
        ]
        : role === "GRIEVANCEADMIN"
        ? [
           
            {
              key: "grievance",
              icon: <AiOutlineForm />,
              label: "Grievance Form",
            },
            {
              key: "grievance-list",
              icon: <AiOutlineOrderedList />,
              label: "Created Grievances",
            },
           {
            key: "assembly-grievance",
            icon: <AiOutlineOrderedList />,
            label: "Assigned Grievance",
          },
           
         
          ]


      : [
          {
            key: "dashboard",
            icon: <AiOutlineDashboard />,
            label: "Dashboard",
          },
          { key: "profile", icon: <AiOutlineUser />, label: "Profile" },
          // {
          //   key: "grievance",
          //   icon: <AiOutlineForm />,
          //   label: "Grievance Form",
          // },
          // {
          //   key: "grievance-list",
          //   icon: <AiOutlineOrderedList />,
          //   label: "Grievance List",
          // },
          
        ];

  const handleLogout = () => {
    navigate("/");
    localStorage.removeItem("email");
    // localStorage.removeItem("password");
    localStorage.removeItem("JWTtoken");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("adminRoleId");
   
  };

  

  const handleDrawerToggle = () => {
    setDrawerVisible(!drawerVisible); // Toggle Drawer visibility
  };

  const menu = (
    <Menu>
      <Menu.Item key="logout">
        <Button
          type="text"
          onClick={handleLogout}
          style={{
            color: "#F86324",
            fontWeight: "bold",
            fontSize: "14px",
            width: "100%",
            border: "none",
            backgroundColor: "transparent",
            padding: "8px 16px",
            borderRadius: "8px",
            transition: "all 0.3s ease",
            position: "relative",
            overflow: "hidden",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#ffe9db";
            e.target.style.transform = "scale(1.05)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
            e.target.style.transform = "scale(1)";
          }}
        >
          Logout
        </Button>
      </Menu.Item>
      <MenuDivider />
      <Menu.Item key="profile">
        <Button
          type="text"
          style={{
            color: "#F86324",
            fontWeight: "bold",
            fontSize: "14px",
            width: "100%",
            border: "none",
            backgroundColor: "transparent",
            padding: "8px 16px",
            borderRadius: "8px",
            transition: "all 0.3s ease",
            position: "relative",
            overflow: "hidden",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#ffe9db";
            e.target.style.transform = "scale(1.05)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
            e.target.style.transform = "scale(1)";
          }}
        >
          <Link to="/login/reset-password">Reset Password</Link>
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Sidebar for larger screens */}
      {!isMobile && (
        <Sider
          // collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
          breakpoint="md"
          collapsedWidth={isMobile ? 0 : 80}
          className="app-sider"
          style={{
            position: "fixed",
            height: "100vh",
            zIndex: 1,
            left: 0,
            top: 0,
            background: colors.primary,
            transition: "all 0.3s ease-in-out",
    boxShadow: collapsed
      ? "4px 0 10px rgba(0, 0, 0, 0.1)"
      : "5px 0 15px rgba(0, 0, 0, 0.2)",
            overflowX: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            className="logo"
            style={{ textAlign: "center", padding: "20px", color: "white" }}
          >
            <h2
      style={{
        color: "white",
        fontSize: collapsed ? "14px" : "20px",
        fontWeight: "bold",
        letterSpacing: "1px",
        textTransform: "uppercase",
        transition: "all 0.3s ease-in-out",
      }}
    >
      {collapsed ? "N" : "Nemmara"}
    </h2>
          </div>

          <Menu
            // theme="light"
            // mode="inline"
            style={{ background: colors.primary, color: "white", flex: 1, overflowY: "auto" }}
            selectedKeys={[selectedKey]}
            onClick={({ key }) => navigate(`/login/${key}`)}
            items={items}
             className="custom-sidebar-menu"
          />
          <div className={`sidebar-version${collapsed ? " sidebar-version-collapsed" : ""}`}>
            v{APP_VERSION}
          </div>
        </Sider>
      )}

      {/* Mobile Drawer */}
      <Drawer
        title=""
        placement="left"
        closable={false}
        onClose={handleDrawerToggle}
        visible={drawerVisible}
        width={250}
        style={{
          background: colors.primary,
          color: "red",
          // padding: "20px 10px",
        }}
        bodyStyle={{
          padding: 0,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Image
          // width="100px"
          src={Logo}
          alt="Menu Image"
          preview={false}
          style={{ width: "190px", height: "160px", cursor: "pointer",marginBottom:"-30px" }}
        />
        <Menu
          // theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
         className="custom-sidebar-menu"
          onClick={({ key }) => {
            setDrawerVisible(false); // Close the drawer on item click
            navigate(`/login/${key}`);
          }}
          style={{
            color:  colors.sidebarText, // Default text color
            backgroundColor: colors.primary,
          }}
          items={items}
        />
        <div className="sidebar-version">v{APP_VERSION}</div>
      </Drawer>

      {/* Main Layout */}
      <Layout
        style={{
          marginLeft: collapsed && isMobile ? 0 : collapsed ? 80 : 200,
          transition: "margin 0.3s",
        }}
      >
        {/* Header */}
      {/* Header */}
<Header
  style={{
    backgroundColor: "#ff6200",
    padding: 0,
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    display: "flex",
    alignItems: "stretch",
    height: 64,
  }}
>
  {/* Logo panel - white, matches sidebar width */}
  {!isMobile ? (
    <div
      style={{
        width: collapsed ? 80 : 200,
        flexShrink: 0,
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "width 0.3s ease-in-out",
      }}
    >
      <img
        src={Logo}
        alt="Voting"
        style={{width: collapsed ? "55px" : "150px",
        height: "150px",
        objectFit: "contain",
        cursor: "pointer",
        margin: 0, }}
      />
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "0 20px",
        flexShrink: 0,
      }}
    >
      <MenuOutlined
        style={{
          fontSize: "20px",
          color: "#fff",
          cursor: "pointer",
        }}
        onClick={handleDrawerToggle}
      />
    </div>
  )}

  {/* Orange section - user info on the right */}
  <div
    style={{
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: "0 20px",
    }}
  >
    <Dropdown overlay={menu} trigger={["click"]}>
      <div
        style={{
          cursor: "pointer",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <Avatar
          src={`https://cdn-icons-png.flaticon.com/512/9542/9542536.png`}
          style={{
            borderRadius: "10px",
            height: "50px",
            width: "50px",
          }}
        />
        <div
          style={{
            display: "grid",
            gridTemplateRows: "auto auto",
            textAlign: "center",
            gap: "2px",
          }}
        >
          <span
            style={{
              color: "#fff",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "1",
            }}
          >
            {firstName && lastName ? `${firstName} ${lastName}` : ""}
          </span>
          <span
            style={{
              fontSize: "12px",
              color: "#fff",
              fontWeight: "600",
              lineHeight: "1",
            }}
          >
            {role}
          </span>
          <span
            style={{
              fontSize: "12px",
              color: "#fff",
              fontWeight: "600",
              lineHeight: "1",
            }}
          >
            {new Date().toLocaleDateString()}
          </span>
        </div>
        <DownOutlined style={{ fontSize: "15px", color: "#fff" }} />
      </div>
    </Dropdown>
  </div>
</Header>

        {/* Content */}
        <Content
          style={{
            margin: "64px 16px 24px",
            padding: 24,
            background: "#fff",
            transition: "margin-left 0.3s ease",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default SimpleLayout;
